import { useReduxState } from 'hooks';
import { Box, BoxBackLink } from 'components/common/box';
import { ReaderBlockDiscussion } from 'components/reader/blocks/discussion';

import type { Course } from 'shared-types';
import type { PageState } from 'types';

interface Props {
  blockId: number;
  boxHeaderContent?: React.ReactNode;
  boxTitleDescription?: React.ReactNode;
  course: Course;
  data: PageState['data'];
}

const Discussion = ({
  blockId,
  boxHeaderContent,
  boxTitleDescription,
  course,
  data
}: Props) => {
  const { messages } = useReduxState();

  return (
    <Box
      headerContent={boxHeaderContent || null}
      title={
        <BoxBackLink
          as={`/admin/courses/${course.slug}/follow/discussions`}
          href="/admin/courses/[courseSlug]/follow/discussions"
          text={messages.tasksAllDiscussions}
        />
      }
      titleDescription={boxTitleDescription || null}
    >
      <div className="discussion">
        <ReaderBlockDiscussion
          blockId={blockId}
          data={data}
          type="discussion"
        />
      </div>
    </Box>
  );
};

export default Discussion;
